import { TRANSLATION_DOCUMENT_CHECKLIST } from '@wdx/shared/utils';
import { APP_CHANGE_OF_CIRCUMSTANCE_LABEL } from './apps.constants';
import { LISTS } from './lists.constants';
import { NETWORK_GRAPH } from './network.constants';
import { PORTFOLIO_360 } from './portfolio.constants';

export enum QuickLinkTypes {
    ExternalUrl = 'ExternalUrl',
    CampaignEngagements = 'CampaignEngagements',
    Cases = 'Cases',
    ClientInsights = 'ClientInsights',
    ClientProducts = 'ClientProducts',
    Clients = 'Clients',
    DocumentChecklist = 'DocumentChecklist',
    Documents = 'Documents',
    Employees = 'Employees',
    ExternalTasks = 'ExternalTasks',
    Feed = 'Feed',
    FormFramework = 'FormFramework',
    Inbox = 'Inbox',
    KYCStatus = 'KYCStatus',
    Lists = 'Lists',
    Modal = 'modal',
    NetworkGraph = 'NetworkGraph',
    Notes = 'Notes',
    Opportunities = 'Opportunities',
    Portfolio360 = 'Portfolio360',
    Profile = 'Profile',
    Tasks = 'Tasks',
    PendingChanges = 'PendingChanges',
    List = 'List',
    ClientSideDmsSearch = 'ClientSideDmsSearch',
}

const QUICK_LINKS_MAPPING = {
    [QuickLinkTypes.Cases]: {
        id: 'casesModal',
    },
    [QuickLinkTypes.Clients]: {
        data: {
            name: 'Clients',
            type: QuickLinkTypes.Clients,
        },
    },
    [QuickLinkTypes.Employees]: {
        data: {
            name: 'Employees',
            type: QuickLinkTypes.Employees,
        },
    },
    [QuickLinkTypes.Opportunities]: {
        id: 'opportunitiesModal',
    },
    [QuickLinkTypes.Feed]: {
        id: 'feedModal',
    },
    [QuickLinkTypes.ExternalTasks]: {
        data: {
            name: 'External Tasks',
            type: QuickLinkTypes.ExternalTasks,
        },
    },
    [QuickLinkTypes.Tasks]: {
        data: {
            name: 'Tasks',
            type: QuickLinkTypes.Tasks,
        },
    },
    [QuickLinkTypes.DocumentChecklist]: {
        data: {
            name: TRANSLATION_DOCUMENT_CHECKLIST,
            type: QuickLinkTypes.DocumentChecklist,
        },
    },
    [QuickLinkTypes.Documents]: {
        data: {
            name: 'Documents',
            type: QuickLinkTypes.Documents,
        },
    },
    [QuickLinkTypes.Notes]: {
        id: 'all-notes',
    },
    [QuickLinkTypes.KYCStatus]: {
        data: {
            name: `KYC Status`,
            type: QuickLinkTypes.KYCStatus,
        },
    },
    [QuickLinkTypes.Lists]: {
        data: {
            name: LISTS,
            type: QuickLinkTypes.Lists,
        },
    },
    [QuickLinkTypes.Inbox]: {
        data: {
            name: 'Inbox',
            type: QuickLinkTypes.Inbox,
        },
    },
    [QuickLinkTypes.Portfolio360]: {
        data: {
            name: PORTFOLIO_360,
            type: QuickLinkTypes.Portfolio360,
        },
    },
    [QuickLinkTypes.ClientProducts]: {
        data: {
            name: 'Client Products',
            type: QuickLinkTypes.ClientProducts,
        },
    },
    [QuickLinkTypes.CampaignEngagements]: {
        data: {
            name: 'Campaign Engagement',
            type: QuickLinkTypes.CampaignEngagements,
        },
    },
    [QuickLinkTypes.ClientInsights]: {
        data: {
            name: 'Client Insights',
            type: QuickLinkTypes.ClientInsights,
        },
    },
    [QuickLinkTypes.NetworkGraph]: {
        data: {
            name: NETWORK_GRAPH,
            type: QuickLinkTypes.NetworkGraph,
        },
    },
    [QuickLinkTypes.PendingChanges]: {
        data: {
            name: APP_CHANGE_OF_CIRCUMSTANCE_LABEL,
            type: QuickLinkTypes.PendingChanges,
        },
    },
    [QuickLinkTypes.List]: {
        data: {
            type: QuickLinkTypes.List,
        },
    },
    [QuickLinkTypes.ClientSideDmsSearch]: {
        data: {
            name: 'ENUM_TABTYPE_CLIENTSIDEDMSSEARCH',
            type: QuickLinkTypes.ClientSideDmsSearch,
        },
    },
};

export const QUICK_LINKS_CLIENTS = { ...QUICK_LINKS_MAPPING };
